import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import SendActorToPositionNodePreview from "../../features/sequence/node_previews/SendActorToPositionNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import Interaction, { InteractionType } from "./Interaction";

export interface ISendActorToPosition extends Interaction {
  npcId: string;
  positionId: string;
  teleport: boolean;
  waitForObjectReached: boolean;
  moveSpeedOverride: number;
}

export const sendActorToPositionInteraction = (): InteractionFactoryEntity => {
  const view = <></>;
  const create = (
    getKeys: (amount: number) => string[]
  ): ISendActorToPosition => {
    return {
      id: GetNewGuid(),
      name: "Send Actor to Pos",
      type: InteractionType.SendActorToPosition,
      npcId: "player",
      positionId: "",
      teleport: false,
      waitForObjectReached: false,
      moveSpeedOverride: 0,
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): ISendActorToPosition => {
    const sendActorToPosition = interaction as ISendActorToPosition;
    return {
      ...sendActorToPosition,
      moveSpeedOverride: sendActorToPosition.moveSpeedOverride ?? 0,
    };
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[]
  ): ISendActorToPosition => {
    const original = interaction as ISendActorToPosition;
    return {
      ...original,
      id: GetNewGuid(),
    };
  };

  const validateErrors = (interaction: Interaction): string[] => {
    const sendActorToPosition = interaction as ISendActorToPosition;
    const errors: string[] = [];

    if (!sendActorToPosition.npcId?.trim()) errors.push("Actor is required");
    if (!sendActorToPosition.positionId?.trim()) {
      errors.push("Position is required");
    }

    return errors;
  };

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <SendActorToPositionNodePreview
        nodeId={nodeId}
        interaction={interaction}
      />
    ),
    FilterType: "Send Actor to Position",
    Create: create,
    Migrate: migrate,
    Copy: copy,
    ValidateErrors: validateErrors,
  };
};
